import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { UitkLink } from 'uitk-react-link';
import { NavigationLinkFragment } from 'graphql/__generated__/types';
import SidebarButton from '../sidebar-button/sidebar-button';
import { getPathName } from '../../../utils/common';
import useSideBarVisibility from '../../../hooks/useSideBarVisiblity';
import { UitkBadgeSize } from 'uitk-react-badge';
import { UitkBadgeStandardTheme } from 'uitk-react-badge/dist/types';

interface SidebarLinkProps {
  navigationLink: NavigationLinkFragment;
  isActive: boolean;
}

const SidebarLink: FC<SidebarLinkProps> = ({ navigationLink, isActive }) => {
  const { push } = useHistory();
  const { setExpandMobileSideBarMenu } = useSideBarVisibility();

  const onLinkClickHandler = (e) => {
    e.preventDefault();
    setExpandMobileSideBarMenu(false);
    push(getPathName(navigationLink.link.action.resource.value));
  };
  return (
    <>
      <UitkLink>
        <a href={navigationLink.link.action.resource.value} onClick={onLinkClickHandler}>
          <SidebarButton
            label={navigationLink.link.text}
            isActive={isActive}
            icon={navigationLink.link.icon}
            badge={
              navigationLink.badge
                ? {
                    text: navigationLink.badge.text,
                    size: navigationLink.badge.size as UitkBadgeSize,
                    theme: navigationLink.badge.theme as UitkBadgeStandardTheme,
                  }
                : null
            }
          />
        </a>
      </UitkLink>
    </>
  );
};

export default SidebarLink;
